import React from "react";
import { useNavigate } from "react-router-dom";
import "./_styles.scss";

const PageNaoEncontrada = () => {
  const navigate = useNavigate();
  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <h1>404</h1>
        <p className="subtitle">Página não encontrada</p>
        <p className="description">
          Desculpe, não conseguimos encontrar a página que você procurava.
        </p>
        <button className="back-button" onClick={() => navigate("/")}>
          Voltar para o Início
        </button>
      </div>
    </div>
  );
};

export default PageNaoEncontrada;
